import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/**  各个模块 */


import store from '@/store'

Vue.use(Router)
Router.prototype.goBack = function () {
	store.commit('UPDATE_ROUTER_IS_BACK', true)
	window.history.go(-1)
}
window.addEventListener('popstate', () => {
	store.commit('UPDATE_ROUTER_IS_BACK', true)
}, false);
export default new Router({
	routes: [
		{
			path: '/',
			component: () => import('@/pages/Home'),
			meta: {
				title: '首页',
			},
			children: [
				{
					path: '/cooperation-visa',
					name: 'cooperationVisa',
					component: () => import('@/pages/cooperation-visa-index'),
					meta: {
						keepAlive: true
					},
				},
				{
					path: '/cooperation-report',
					name: 'cooperationReport',
					component: () => import('@/pages/cooperation-report-index'),
					meta: {
						keepAlive: true
					},
				},
				{
					path: '/cooperation-contract',
					name: 'cooperationContract',
					meta: {
						keepAlive: true,
						water:true
					},
					component: () => import('@/pages/cooperation-contract-index'),
				},
				{
					path: '/cooperation-pay',
					name: 'cooperationPay',
					component: () => import('@/pages/cooperation-pay-index'),
					meta: {
						keepAlive: true
					},
				},
				{
					path: '/cooperation-accounts',
					name: 'cooperationAccounts',
					component: () => import('@/pages/cooperation-accounts-index'),
					meta: {
						keepAlive: true
					},
				},
				{
					path: '/cooperation-contract-agreement',
					name: 'contractAgreement',
					component: () => import('@/pages/cooperation-contract-agreement'),
					meta: {
						keepAlive: true
					},
				},
			]
		},
		{
			path: '/cooperation-detail',
			name: 'cooperationDetail',
			component: () => import('@/pages/cooperation-detail'),
			meta: {
				keepAlive: false
			},
		},
		{
			path: '/cooperation-agreement-detail',
			name: 'cooperationAgreementDetail',
			component: () => import('@/pages/cooperation-agreement-detail'),
			meta: {
				keepAlive: false
			},
		},
		{
			path: '/cooperation-overview',
			name: 'cooperationOverview',
			component: () => import('@/pages/cooperation-overview-packge/index'),
			meta: {
				keepAlive: true
			},
		},
		{
			path: '/invite-tenders',
			name: 'inviteTenders',
			component: () => import('@/pages/invite-tenders-packge/index'),
			meta: {
				keepAlive: true,
				noNeedLogin:true
			},
		},
		{
			path: '/corrup-report',
			name: 'corrupReport',
			component: () => import('@/pages/corrup-report/index'),
			meta: {
				keepAlive: true,
				noNeedLogin:true
			},
		},
		{
			path: '/complain-suggest',
			name: 'complainSuggest',
			component: () => import('@/pages/complain-suggest/index'),
			meta: {
				keepAlive: true,
				noNeedLogin:true
			},
		},
		{
			path: '/use-opinion',
			name: 'useOpinion',
			component: () => import('@/pages/use-opinion/index'),
			meta: {
				keepAlive: true,
				noNeedLogin:true

			},
		},
		{
			path: '/notice-report',
			name: 'noticeReport',
			component: () => import('@/pages/corrup-report/components/notice-report'),
			meta: {
				keepAlive: true
			},
		},
		{
			path: '/recruitment-info',
			name: 'recruitmentInfo',
			component: () => import('@/pages/recruitment-info/home'),
			meta: {
				keepAlive: true,
				noNeedLogin:true
			},
		},
		{
			path: '/recruitment-notice-detail',
			name: 'recruitmentNoticeDetail',
			component: () => import('@/pages/recruitment-info/components/recruitment-notice-detail'),
			meta: {
				keepAlive: false,
				noNeedLogin:true
			},
		},
		{
			path: '/tendering-notice-detail',
			name: 'tenderingNoticeDetail',
			component: () => import('@/pages/recruitment-info/components/tendering-notice-detail'),
			meta: {
				keepAlive: false,
				noNeedLogin:true

			},
		},
		{
			path: '/bidding-notice-detail',
			name: 'biddingNoticeDetail',
			component: () => import('@/pages/recruitment-info/components/bidding-notice-detail'),
			meta: {
				keepAlive: false,
				noNeedLogin:true
			},
		},

		{
			path: '/author',
			name: 'Author',
			component: () => import('@src/_common/pages/Author'),
			meta: {
				trust: true,
				noNeedLogin: true
			}
		},
		{
			path: '/login',
			name: 'Login',
			component: () => import('@src/_common/pages/Login'),
			meta: {
				trust: true,
				noNeedLogin: true
			}
		},
		{
			path: '*',
			name: '404',
			component: () => import('@src/_common/pages/404'),
			meta: {
				trust: true,
				noNeedLogin: true,
				title: '404'
			}
		}
	]
})
